import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DropCards.css';
import React, { useEffect, useState } from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../../utils';
import { convertToAnalyticObject } from '../../../utils/analytics';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
import RouterLink from '../../atoms/RouterLink';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import LazyPicture from '../../atoms/LazyPicture';
var Cards = function Cards(_ref) {
  var item = _ref.item,
    itemsLength = _ref.itemsLength,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var _useState = useState(canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false),
    _useState2 = _slicedToArray(_useState, 2),
    mediaWidth992px = _useState2[0],
    setMediaWidth992px = _useState2[1];
  var _useState3 = useState(canUseDOM ? window.matchMedia("(max-width: 1200px)").matches : false),
    _useState4 = _slicedToArray(_useState3, 2),
    mediaWidth1200px = _useState4[0],
    setMediaWidth1200px = _useState4[1];
  var sitecoreContext = useSitecoreContext();
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var cardImageSrc = get(item, 'image.jss.value.src');
  var cardImageAlt = get(item, 'image.jss.value.alt');
  var hasTitle = get(item, 'title.jss.value');
  var hasDescription = Boolean(get(item, 'description.jss.value'));
  var ctaLabel = get(item, 'ctaLabel.jss.value');
  var ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener("resize", function () {
        setMediaWidth992px(window.matchMedia("(max-width: 992px)").matches);
        setMediaWidth1200px(window.matchMedia("(max-width: 1200px)").matches);
      });
    }
    return function () {
      if (canUseDOM) {
        window.addEventListener("resize", function () {
          setMediaWidth992px(window.matchMedia("(max-width: 992px)").matches);
          setMediaWidth1200px(window.matchMedia("(max-width: 1200px)").matches);
        });
      }
    };
  }, []);
  var renderContentInLink = function renderContentInLink(children) {
    if (!ctaLinkHref && !pageEditing) return children;
    var linkTitle = '';
    if (hasTitle) {
      linkTitle = hasTitle;
    } else {
      linkTitle = cardImageAlt ? cardImageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = "".concat(ctaLabel, " | ").concat(linkTitle);
    }
    if (item.ctaLink && item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === "_blank") {
      linkTitle = linkTitle ? "".concat(linkTitle) : "";
    }
    return /*#__PURE__*/React.createElement(Link, {
      "aria-label": linkTitle,
      field: item.ctaLink.jss
    }, children);
  };
  var renderLink = function renderLink() {
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    var preTitle = hasTitle ? "".concat(get(item, 'title.jss.value'), " | ") : '';
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "general-card-button",
      href: item.ctaLink.jss.value.href,
      title: "".concat(preTitle).concat(ctaLabel),
      linktype: "external",
      openInSameTab: true,
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['discoverMoreAnalytics'], params), [item.title.jss.value, item.ctaLabel.jss.value]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text"
    }, ctaLabel && ctaLinkHref ? ctaLabel : null), ctaLabel && ctaLinkHref ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  var defaultCardRender = function defaultCardRender() {
    return /*#__PURE__*/React.createElement("div", null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card--item__icon"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-box cardBoxDefault theme-contrast"
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), hasTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "h__icon iconCircle iconDropCircle"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 992px)",
      srcSet: cardImageSrc
    }), /*#__PURE__*/React.createElement("img", {
      src: cardImageSrc,
      alt: cardImageAlt
    }))) : null, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardTitle",
      field: item.title && item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, renderLink())));
  };
  var uniqueCardRenderForTwoOrThreeItems = function uniqueCardRenderForTwoOrThreeItems() {
    return /*#__PURE__*/React.createElement("div", null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
      className: "card--item__icon"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-box uniqueCardBox theme-contrast"
    }, /*#__PURE__*/React.createElement("div", {
      className: "uniqueCardBoxDesktop"
    }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
      onClick: function onClick() {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), hasTitle);
      },
      useEmptyPlaceholder: true,
      hover: true,
      className: "h__icon iconDropCircle uniqueIconCircle"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(max-width: 992px)",
      srcSet: cardImageSrc
    }), /*#__PURE__*/React.createElement("img", {
      src: cardImageSrc,
      alt: cardImageAlt
    }))) : null, /*#__PURE__*/React.createElement("div", {
      className: "textContainer"
    }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardTitle",
      field: item.title && item.title.jss
    }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "h__title body-large cardDescription",
      field: item.description && item.description.jss
    }) : null, mediaWidth992px || itemsLength === 4 && mediaWidth1200px ? null : renderLink())), mediaWidth992px || itemsLength === 4 && mediaWidth1200px ? renderLink() : null)));
  };
  return itemsLength === 2 || itemsLength === 3 && mediaWidth992px || itemsLength === 4 && mediaWidth1200px ? uniqueCardRenderForTwoOrThreeItems() : defaultCardRender();
};
var DropCards = function DropCards(_ref2) {
  var fields = _ref2.fields,
    params = _ref2.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var defaultCardsHasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var defaultCardsHasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  var childrenItems = get(fields, 'data.item.children', []);
  var ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  var ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var items = childrenItems.length ? childrenItems.filter(function (item) {
    return item.title && item.description;
  }) : [];
  var classItemsContainerMap = {
    2: "twoItemsContainer",
    3: "threeItemsContainer",
    4: "fourItemsContainer"
  };
  var classItemWidthMap = {
    1: "oneItemWidth",
    2: "twoItemWidth",
    3: "threeItemWidth",
    4: "fourItemWidth"
  };
  var renderButtonLink = function renderButtonLink() {
    return /*#__PURE__*/React.createElement("div", {
      className: "btnLink"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "btn",
      href: ctaLink,
      title: ctaLabel,
      openInSameTab: true,
      linktype: "external",
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [fields.data.item.title.jss.value, ctaLabel]);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "btnText"
    }, ctaLabel)));
  };
  var renderItems = function renderItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "itemWidth ".concat(classItemWidthMap[items.length]),
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: index
      }, /*#__PURE__*/React.createElement(Cards, {
        item: item,
        itemsLength: items.length,
        eventsAnalytics: eventsAnalytics,
        params: params
      }));
    });
  };
  var renderItems04 = function renderItems04() {
    return /*#__PURE__*/React.createElement("div", {
      className: classItemsContainerMap[items.length]
    }, renderItems());
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, defaultCardsHasTitle && items.length < 5 ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, defaultCardsHasDescription && items.length < 5 ? /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    className: "body-large c__txt componentDescriptionWithoutCarousel",
    field: fields.data.item.description.jss
  }) : null, items.length < 5 ? renderItems04() : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(defaultCardsHasTitle ? 'card__head' : 'cardHeadOnlyWithPagination')
    }, defaultCardsHasTitle || defaultCardsHasDescription ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null, defaultCardsHasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "p componentDescription",
      field: fields.data.item.description.jss
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right"
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], params), ['previous']);
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], params), ['next']);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1281
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1280,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    })), ctaLink && ctaLabel ? /*#__PURE__*/React.createElement("div", {
      className: "paginationAndLinkContainer"
    }, renderButtonLink(), /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bubblesAnalytics'], params));
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "paginationWithoutLinkContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bubblesAnalytics'], params));
    }))));
  }) : null);
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl,
    className = _ref4.className,
    style = _ref4.style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var generalItemsContainer = "\n  display: flex;\n  gap: 10px 20px;\n";
export var commonStyles = "c13r0fx6";
export var ltrStyles = "l18dk395";
export var rtlStyles = "r1gi7dis";
export { DropCards };